(function () {
  function api(method, path, body) {
    var url = (window.DELVIA_API_BASE || '') + path;
    var c = window.DELVIA_CUSTOMER;
    if (!c) return Promise.reject(new Error('not_logged_in'));
    var payload = Object.assign({ customer_id: c.id, sig: c.sig }, body || {});
    return fetch(url, {
      method: method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.detail || j.error || ('http_' + r.status));
        return j;
      });
    });
  }

  function apiGet(path) {
    var c = window.DELVIA_CUSTOMER;
    if (!c) return Promise.reject(new Error('not_logged_in'));
    var url = (window.DELVIA_API_BASE || '') + path
      + (path.indexOf('?') >= 0 ? '&' : '?')
      + 'customer_id=' + encodeURIComponent(c.id)
      + '&sig=' + encodeURIComponent(c.sig);
    return fetch(url).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.detail || j.error || ('http_' + r.status));
        return j;
      });
    });
  }

  window.delviaCustomer = {
    getProfile: function () { return apiGet('/customer/profile'); },
    updateProfile: function (data) { return api('POST', '/customer/profile', data); },
    createAddress: function (data) { return api('POST', '/customer/addresses', data); },
    updateAddress: function (id, data) { return api('POST', '/customer/addresses/' + id, data); },
    deleteAddress: function (id) { return api('POST', '/customer/addresses/' + id + '/delete'); },
    setDefaultAddress: function (id) { return api('POST', '/customer/default_address/' + id); },
  };
})();
